<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="UserId"
      ref="list"
      unit="用户"
      :show-summary="true"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="false"
      :show-query="true"
      :get-data-func="api.detailList"
      urlHash="business/purchase/emptordetails"
      :resetDataFunc="resetDataFunc"
      :is-dialog-query="isDialogQuery"
      isShowText
      :showTextArr="showTextArr"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="onPrint">打印</el-button>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import Bus from "@/utils/bus";
export default {
  mixins: [listMixin],
  components: { list },
  props: {
    //是否弹窗查询
    isDialogQuery: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/pu/puOrder").default,
      trendShow: true,
      
      showTextArr: [
        {
          type: "time",
          label: "单据时间",
          startKey: "DocDateStart",
          endKey: "DocDateEnd",
        },
        {
          type: "data",
          label: "供应商",
          key: "TradeUnitName",
        },
        {
          type: "data",
          label: "存货",
          key: "ProductName",
        },
      ],
    };
  },

  activated() {
    if (this.$refs.list.isSetQuery === false) {
      this.getData();
    }
  },
  mounted() {
    if (!this.$permission.canPrice("/business/purchase/emptordetails")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "Amount");
      if (findIndex >= 0) list.tableList.splice(findIndex, 1);
      const findIndex0 = list.tableList.findIndex(item => item.tableName == "TaxLimit");
      if (findIndex0 >= 0) list.tableList.splice(findIndex0, 1);
      const findIndex1 = list.tableList.findIndex(item => item.tableName == "Price");
      if (findIndex1 >= 0) list.tableList.splice(findIndex1, 1);
      const findIndex2 = list.tableList.findIndex(item => item.tableName == "TaxPrice");
      if (findIndex2 >= 0) list.tableList.splice(findIndex2, 1);
      const findIndex5 = list.tableList.findIndex(item => item.tableName == "TaxAmount");
      if (findIndex5 >= 0) list.tableList.splice(findIndex5, 1);
      const findIndex6 = list.tableList.findIndex(item => item.tableName == "Offer");
      if (findIndex6 >= 0) list.tableList.splice(findIndex6, 1);
      const findIndex7 = list.tableList.findIndex(item => item.tableName == "TaxRate");
      if (findIndex7 >= 0) list.tableList.splice(findIndex7, 1);
    }
    Bus.$on("closeTag", (route) => {
      console.log("route.fullPath 采购订单明细表", route.fullPath);
      console.log("this.$route.fullPath 采购订单明细表", this.$route.fullPath);

      if (route.fullPath === "/business/purchase/emptordetails") {
        this.$refs.list.data = [];
        this.$refs.list.isSetQuery = false;
      }
    });
  },
  methods: {
    closed(isSetQuery) {
      if (!isSetQuery) {
        this.closeSelectedTag(this.$route);
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "index") {
          // to reload home page
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    onPrint() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      var data = {
        Params: params,
        TableNames: list.tableList,
        ParamsData: list.paramsData,
      };
      sessionStorage.setItem("emptordetails_print", JSON.stringify(data));

      var origin = location.origin;
      window.open(origin + "/#/business/purchase/emptordetails/print");
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.detailExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    resetDataFunc(data){
      data.forEach(item => {
        if(item.IsGift){
          item.IsGiftText = '有'
        }else{
          item.IsGiftText = '无'
        }
      })
      console.log('======data=========', data)
      return data
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>